import axios from 'axios'
import apiConfig from '../../../../../config/api-config'

const getMemberSummary = ({ accessToken }) =>
  axios.get(
    `${apiConfig.apiURL}/loyalty/v1/members/me/summary`,
    { headers: { apikey: apiConfig.apiKey, accessToken } },
  )

export default getMemberSummary
